import { defineType, defineField } from 'sanity';
import { HeroBannerSchema } from './hero-banners';
import { AboutUsSectionSchema } from './about-us-section';

export default defineType({
	name:   'homePage',
	title:  'Home Page',
	type:   'document',
	fields: [

		// defineField({
		// 	name:   'heroBanner',
		// 	title:  'Hero Banner',
		// 	type:   'object',
		// 	fields: [
		// 		defineField({
		// 			name:       'image',
		// 			title:      'Image  (16:9 aspect ratio)',
		// 			type:       'image',
		// 			options:    { hotspot: true },
		// 			validation: Rule => Rule.required(),
		// 		}),
		// 		defineField({
		// 			name:       'imageMobile',
		// 			title:      'Image Mobile (3:4 aspect ratio)',
		// 			type:       'image',
		// 			options:    { hotspot: true },
		// 			validation: Rule => Rule.required(),
		// 		}),
		// 		defineField({
		// 			name:       'title',
		// 			title:      'Title',
		// 			type:       'localizedText',
		// 			validation: Rule => Rule.required(),
		// 		}),
		// 		defineField({
		// 			name:  'description',
		// 			title: 'Description',
		// 			type:  'localizedText',
		// 		}),
		// 		defineField({
		// 			name:  'cta',
		// 			title: 'Call to Action Label',
		// 			type:  'localizedText',
		// 		}),
		// 		defineField({
		// 			name:       'link',
		// 			title:      'CTA Link',
		// 			type:       'url',
		// 			validation: Rule => Rule.uri({ allowRelative: true }),
		// 		}),
		// 	],
		// 	preview: {
		// 		select: {
		// 			title: 'title.en',
		// 			media: 'image',
		// 		},
		// 		prepare({ title, media }) {
		// 			return {
		// 				title: title || 'Untitled Hero Banner',
		// 				media,
		// 			};
		// 		},
		// 	},
		// }),
		defineField(HeroBannerSchema),
		defineField(AboutUsSectionSchema),
	],
	preview: { prepare: () => ({ title: 'Home Page' }) },
});